import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { ToasterConfig } from '../../config/ToasterConfig';
import useProgrammingLocationService from '../../services/backoffice/hooks/useProgrammingLocationService';

interface ProgrammingLocationRefreshButtonProps {
    onRefreshComplete?: () => void;
    disabled?: boolean;
    size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';
}

/** Polling da lista após 202 — job Hangfire não devolve status. */
const REFRESH_POLL_FIRST_DELAY_MS = 5_000;
const REFRESH_POLL_INTERVAL_MS = 5_000;
const REFRESH_POLL_MAX_ATTEMPTS = 12;

const scheduleListPolling = (onPoll: () => void) => {
    let attempts = 0;
    const run = () => {
        onPoll();
        attempts += 1;
        if (attempts < REFRESH_POLL_MAX_ATTEMPTS) {
            window.setTimeout(run, REFRESH_POLL_INTERVAL_MS);
        }
    };
    window.setTimeout(run, REFRESH_POLL_FIRST_DELAY_MS);
};

const ProgrammingLocationRefreshButton: React.FC<ProgrammingLocationRefreshButtonProps> = ({
    onRefreshComplete,
    disabled = false,
    size = 'small'
}) => {
    const { loading, refreshProgrammingLocations } = useProgrammingLocationService();

    const handleRefresh = async () => {
        try {
            const result = await refreshProgrammingLocations();

            toast.info(
                result.message || 'Atualização de localizações enfileirada. Os dados serão atualizados em segundo plano.',
                ToasterConfig.success
            );

            if (onRefreshComplete) {
                scheduleListPolling(onRefreshComplete);
            }
        } catch (error: any) {
            console.error('Erro ao atualizar localizações:', error);
            
            const errorMessage = error?.response?.data?.message || 
                               error?.message || 
                               'Erro interno ao atualizar localizações das programações';
            
            toast.error(errorMessage, ToasterConfig.error);
        }
    };

    return (
        <Button
            color="green"
            size={size}
            loading={loading}
            disabled={disabled || loading}
            onClick={handleRefresh}
            icon
            labelPosition="left"
            style={{ minHeight: '36px', height: '36px' }}
        >
            <Icon name="refresh" />
            Atualizar Localizações
        </Button>
    );
};

export default ProgrammingLocationRefreshButton; 